module.exports = __webpack_public_path__ + "img/diamond-half.633be3eb.svg";